<sim-basic-material-dialog
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-exclamation-triangle', fontSet: 'fad'}"
	[headerText]="getDialogTitle()"
	[matDialogData]="data"
	[rect]="rect"
	[showClosingX]="false"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="titleContainer">
			@switch (data.canRecord.result) {
				@case (CanRecordResult.RecordingIsPreparedByOtherActiveRecorder) {
					<div
						[innerHTML]="
							T.CAN_RECORD_RECORDINGISPREPAREDBYOTHERACTIVERECORDER_DESC
								| translate
									: {
											sessionTitle: data.canRecord.additionalData?.newRecording?.teamTrainingSession?.title,
											recorderName: data.canRecord.additionalData?.newRecording?.recorder?.name,
									  }
						"
						class="mat-h3"
					></div>
				}
				@case (CanRecordResult.RecordingHasOtherActiveRecorder) {
					<div
						[innerHTML]="
							T.CAN_RECORD_RECORDINGHASOTHERACTIVERECORDER_DESC
								| translate
									: {
											sessionTitle: data.canRecord.additionalData?.newRecording?.teamTrainingSession?.title,
											recorderName: data.canRecord.additionalData?.newRecording?.recorder?.name,
									  }
						"
						class="mat-h3"
					></div>
				}
				@case (CanRecordResult.RecorderHasOtherActiveRecording) {
					<div
						[innerHTML]="
							T.CAN_RECORD_RECORDERHASOTHERACTIVERECORDING_DESC
								| translate
									: {
											sessionTitle: data.canRecord.additionalData?.runningRecording?.teamTrainingSession?.title,
									  }
						"
						class="mat-h3"
					></div>
				}
			}
		</div>
	</ng-container>

	<ng-container actions>
		<button (click)="navigateToDashboard()" color="accent" mat-button style="margin-right: auto">
			<mat-icon fontIcon="fa-home" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
			{{ T.BUTTON_GO_TO_HOME_POSITION | translate }}
		</button>
		@switch (data.canRecord.result) {
			@case (CanRecordResult.RecorderHasOtherActiveRecording) {
				<button (click)="navigateToOldRecording()" color="accent" mat-button style="margin-right: auto">
					<mat-icon fontIcon="fa-step-forward" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
					{{ T.CAN_RECORD_NAVIGATETOCURRENT | translate }}
				</button>
				<button (click)="stopOldRecordingAndProceed()" color="accent" mat-button style="margin-right: auto">
					<mat-icon fontIcon="fa-forward" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
					{{ T.CAN_RECORD_STOPCURRENTANDPROCEED | translate }}
				</button>
			}
		}
	</ng-container>
</sim-basic-material-dialog>
